// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React, { useState } from 'react';
import { KebabMenu } from '@metarouter-private/mr-mui';

import { useQueryAllAnalyticsFiles } from 'ion-experimental/api/analytics-files';
import BulkUploadModal from '../BulkUploadModal';
import BulkDownloadModal from '../BulkDownloadModal';
import BulkBuildAndDownloadModal from '../BulkBuildAndDownload';
import BulkAutoDeployModal from '../BulkAutoDeploy';

const FILE_HOSTING_TYPE = {
  SELF: 'SELF',
  META_ROUTER: 'META_ROUTER',
};

export default function BulkActionsMenu() {
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [buildAndDownloadModalOpen, setBuildAndDownloadModalOpen] = useState(false);
  const [autoDeployModalOpen, setAutoDeployModalOpen] = useState(false);

  const { data: analyticsFiles } = useQueryAllAnalyticsFiles({ fetchPolicy: 'cache-and-network' });

  const hasFiles = analyticsFiles && analyticsFiles.length > 0;
  const hasSelfHostedFiles = analyticsFiles?.some(file => file.settings?.fileHostingType === FILE_HOSTING_TYPE.SELF);
  const hasMetaRouterFiles = analyticsFiles?.some(
    file => file.settings?.fileHostingType === FILE_HOSTING_TYPE.META_ROUTER
  );

  const menuItems = [
    {
      label: 'Bulk Download Config',
      onClick: () => setDownloadModalOpen(true),
      disabled: !hasFiles,
    },
    {
      label: 'Bulk Upload Config',
      onClick: () => setUploadModalOpen(true),
    },
    {
      label: 'Bulk Build & Download',
      onClick: () => setBuildAndDownloadModalOpen(true),
      disabled: !hasSelfHostedFiles,
    },
    {
      label: 'Bulk Build & Deploy to Cluster',
      onClick: () => setAutoDeployModalOpen(true),
      disabled: !hasMetaRouterFiles,
    },
  ];

  return (
    <>
      <KebabMenu items={menuItems} testId="bulk-actions-menu" />
      <BulkUploadModal open={uploadModalOpen} onClose={() => setUploadModalOpen(false)} />
      <BulkDownloadModal open={downloadModalOpen} onClose={() => setDownloadModalOpen(false)} />
      <BulkBuildAndDownloadModal open={buildAndDownloadModalOpen} onClose={() => setBuildAndDownloadModalOpen(false)} />
      <BulkAutoDeployModal open={autoDeployModalOpen} onClose={() => setAutoDeployModalOpen(false)} />
    </>
  );
}
